import { injectable } from 'inversify';

import { HttpService } from '@vk-hr-tek/core/http';
import { UnmarshallerService } from '@vk-hr-tek/core/unmarshaller';

import {
  AvailableAbsenceFilters,
  AbsenceListResponse,
  AbsenceCompanyOptionsList,
} from '@app/gen/absences';

import { GetAbsencesCompaniesDto, GetCompanyAbsencesListDto } from '../dto';

@injectable()
export class AbsencesListService {
  constructor(
    private http: HttpService,
    private unmarshaller: UnmarshallerService,
  ) {}

  async getCompanyAbsencesList(
    getCompanyAbsencesListDto: GetCompanyAbsencesListDto,
  ) {
    const { limit, offset, filters, companyId, year, month } =
      getCompanyAbsencesListDto;

    if (filters?.include_subunits) {
      const includeSubunitsBool = filters.include_subunits === 'true';

      filters.include_subunits = includeSubunitsBool;
    }

    const requestFilters = { ...filters, company_id: companyId, year, month };

    const result = await this.unmarshaller.unmarshall(
      await this.http.post(
        '/absences/company/list',
        {
          pagination: {
            limit,
            offset,
          },
          filters: requestFilters,
        },
        {
          withSide: true,
        },
      ),
      AbsenceListResponse,
    );

    return result;
  }

  async getEmployeeAbsencesList(
    getEmployeeAbsencesListDto: GetCompanyAbsencesListDto,
  ) {
    const { limit, offset, filters, companyId, year, month } =
      getEmployeeAbsencesListDto;

    const requestFilters = { ...filters, company_id: companyId, year, month };

    const result = await this.unmarshaller.unmarshall(
      await this.http.post(
        '/absences/employee/list',
        {
          pagination: {
            limit,
            offset,
          },
          filters: requestFilters,
        },
        {
          withSide: true,
        },
      ),
      AbsenceListResponse,
    );

    return result;
  }

  async getAbsenceFilters(companyId: string, forColleagues = false) {
    const result = await this.unmarshaller.unmarshall(
      await this.http.get(
        `/absence_available_filters/${companyId}`,
        {
          ...(forColleagues
            ? {
                for_colleagues: true,
              }
            : {}),
        },
        { withSide: true },
      ),
      AvailableAbsenceFilters,
    );

    return result.filters;
  }

  async getAbsenceCompanies(getAbsencesCompaniesDto: GetAbsencesCompaniesDto) {
    const result = await this.unmarshaller.unmarshall(
      await this.http.get('/absences/companies', getAbsencesCompaniesDto, {
        withSide: true,
      }),
      AbsenceCompanyOptionsList,
    );

    return result.items;
  }
}
